<template>
    <el-dialog
        class="notice-dialog"
        :visible="noticeDialogShow"
        width="680px"
        :before-close="closeHandle"
        :close-on-click-modal="false"
    >
        <div class="slot-title" slot="title">
            <div class="slot-title-top">{{$t('important_Notice')}}</div>
        </div>
        <div class="self-title">
            <div class="notice-title">{{noticeDialogInfo.title}}</div>
            <div class="time">{{noticeDialogInfo.updateTime}}</div>
        </div>
<!--    ref="contentouter"  -->
        <div
          class="content-outer"
          :style="{
            height: outerHeight + 'px',
            minHeight: '230px',
          }"
        >
            <el-scrollbar style="height: 100%;">
                <div
                  ref="qlcontainer"
                  class="content ql-container"
                  v-html="noticeDialogInfo.content"
                ></div>
            </el-scrollbar>
        </div>
<!--      -->
        <div class="self-footer" slot="footer">
            <div class="check-box-outer">
                <el-checkbox
                        class="check-box"
                        v-model="isNoNeverShow"
                >{{$t('do_not_show_again')}}</el-checkbox>
            </div>
            <div class="btn-outer">

                <el-button
                    round
                    size="small"
                    type="primary"
                    @click="knowHandle"
                >{{$t('Got_it')}}</el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
  import { readNoticeDialog } from '@/api/user'
  import { mapGetters } from 'vuex'
  export default {
    name: 'noticeDialog',
    data() {
      return {
        isNoNeverShow: false,
        clientHeight: '',// 浏览器可视区域高度
        outerHeight: ''
      };
    },
    watch: {
      noticeDialogShow(newValue, oldValue) {
        if(newValue && this.noticeDialogInfo){
          this.assienHeight();
          /*this.getOuterStyle();*/
        }
      },
      clientHeight(){
        // 如果clientHeight 发生改变,这个函数就会运行
        this.changeFixed(this.clientHeight);
      }
    },
    computed: {
      ...mapGetters(['userInfo','noticeDialogShow','noticeDialogInfo']),

    },
    mounted(){
      this.clientHeight = document.documentElement.clientHeight;
      this.assigen();
      window.onresize = (() => {
        this.assigen();
      })
    },
    methods: {
      changeFixed(clientHeight){//
        this.outerHeight = clientHeight - 80 - 300 - 24;
      },
      assigen(){
        this.clientHeight = document.documentElement.clientHeight;
        this.outerHeight = this.clientHeight - 80 - 300 - 24;
      },

      getOuterStyle(){

        let computedHeight = window.innerHeight;

        if(this.contentHeight < (computedHeight - 300)){
          this.outerStyle = {
            // height: this.contentHeight + 'px',
            maxHeight: (computedHeight - 300 - 100 - 80) + 'px',
          }
        }else {
          this.outerStyle = {
            // height: (computedHeight - 300 - 100 - 80) + 'px',
            maxHeight: (computedHeight - 300 - 100 - 80) + 'px',
          }
        }

      },
      assienHeight(){
        this.contentHeight = this.$refs.qlcontainer.clientHeight;

        console.log(this.contentHeight);
      },
      knowHandle(){
        this.$store.commit('setNoticeDialogShow', false);
        // 关闭窗口
        if(this.isNoNeverShow){
          //ajax
          readNoticeDialog({
            custId: this.userInfo.id,
            popUpId: this.noticeDialogInfo.id,
          }).then((res) => {
            console.log(res);
          })
        }
      },
      closeHandle(){
        this.$store.commit('setNoticeDialogShow', false);
      }
    }
  };
</script>
<style lang="scss" scoped>
    @import "../../assets/scss/variable";
    .notice-dialog {
        .slot-title {
            .slot-title-top {
                font-size: 20px;
                color: #333333;
                font-weight: bold;

            }
            .slot-title-bot {
                font-size: 12px;
                color: #666666;
                margin-top: 10px;
            }
        }
        .content-outer {
            /*min-height: 300px;
            height: 400px;*/
            //max-height: calc(100vh - 300px - 100px - 80px);
            .content {
                padding: 20px;
                padding-top: 0;
            }
        }
        .btn-outer {
            width: 100%;
            text-align: center;
            padding-top: 20px;
            padding-bottom: 10px;
        }
        .self-title{
            padding: 20px;
            .notice-title {
                font-size: 16px;
                font-weight: bold;
                color: #333333;
                margin-bottom: 15px;
            }
        }
        .check-box-outer {
            text-align: left;
        }
      .self-footer {

      }
    }
    @media screen and (max-width: 768px){
        .notice-dialog {
            .content-outer {
                height: 80vh;
            }
        }
    }
</style>

<style lang="scss">
    .notice-dialog {
        img {
            max-width: 100%;
        }
        .el-dialog__header {
            background-color: #f7f9fa;
            padding-bottom: 20px;
        }
        .el-dialog {
            margin-top: 24px!important;
            min-height: 500px;
            height: calc(100vh - 48px - 24px - 20px) ;
            border-radius: 10px;
            overflow: hidden;
            .el-dialog__body {
                padding: 0;
            }
        }
    }
</style>
